import React from "react";

const Logo = () => {
  return (
    <div>
      <img src='/mywork-logo.svg' alt='MyWork Logo' />
    </div>
  );
};

export default Logo;
